// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_TxQIB {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._ncFormBox_BhWbh {
  display: flex;
  flex-direction: column;
  gap: calc(1 * var(--default-grid-baseline));
}
._ncFormBox_BhWbh._ncFormBox_row_F5s-i {
  flex-direction: row;
}
._ncFormBox__item_655o7 {
  border-radius: var(--border-radius-small) !important;
}
._ncFormBox_col_nIEpL {
  flex-direction: column;
}
._ncFormBox_col_nIEpL ._ncFormBox__item_655o7:first-child {
  border-start-start-radius: var(--border-radius-element) !important;
  border-start-end-radius: var(--border-radius-element) !important;
}
._ncFormBox_col_nIEpL ._ncFormBox__item_655o7:last-child {
  border-end-start-radius: var(--border-radius-element) !important;
  border-end-end-radius: var(--border-radius-element) !important;
}
._ncFormBox_row_F5s-i {
  flex-direction: row;
}
._ncFormBox_row_F5s-i ._ncFormBox__item_655o7 {
  flex: 1 1;
}
._ncFormBox_row_F5s-i ._ncFormBox__item_655o7:first-child {
  border-start-start-radius: var(--border-radius-element) !important;
  border-end-start-radius: var(--border-radius-element) !important;
}
._ncFormBox_row_F5s-i ._ncFormBox__item_655o7:last-child {
  border-end-end-radius: var(--border-radius-element) !important;
  border-start-end-radius: var(--border-radius-element) !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcFormBox-D_5h4Op_.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kEAAkE;EAClE,gEAAgE;AAClE;AACA;EACE,gEAAgE;EAChE,8DAA8D;AAChE;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,kEAAkE;EAClE,gEAAgE;AAClE;AACA;EACE,8DAA8D;EAC9D,gEAAgE;AAClE","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_TxQIB {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._ncFormBox_BhWbh {\n  display: flex;\n  flex-direction: column;\n  gap: calc(1 * var(--default-grid-baseline));\n}\n._ncFormBox_BhWbh._ncFormBox_row_F5s-i {\n  flex-direction: row;\n}\n._ncFormBox__item_655o7 {\n  border-radius: var(--border-radius-small) !important;\n}\n._ncFormBox_col_nIEpL {\n  flex-direction: column;\n}\n._ncFormBox_col_nIEpL ._ncFormBox__item_655o7:first-child {\n  border-start-start-radius: var(--border-radius-element) !important;\n  border-start-end-radius: var(--border-radius-element) !important;\n}\n._ncFormBox_col_nIEpL ._ncFormBox__item_655o7:last-child {\n  border-end-start-radius: var(--border-radius-element) !important;\n  border-end-end-radius: var(--border-radius-element) !important;\n}\n._ncFormBox_row_F5s-i {\n  flex-direction: row;\n}\n._ncFormBox_row_F5s-i ._ncFormBox__item_655o7 {\n  flex: 1 1;\n}\n._ncFormBox_row_F5s-i ._ncFormBox__item_655o7:first-child {\n  border-start-start-radius: var(--border-radius-element) !important;\n  border-end-start-radius: var(--border-radius-element) !important;\n}\n._ncFormBox_row_F5s-i ._ncFormBox__item_655o7:last-child {\n  border-end-end-radius: var(--border-radius-element) !important;\n  border-start-end-radius: var(--border-radius-element) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
